module.exports = __webpack_public_path__ + "static/media/haskell.71df05b3.png";